import * as Bluebird from "bluebird";
import Cache from "../services/Cache";
import keyStore from "./keyStore.service";
import { landingPage } from "./location.manager";
import { withPrefix } from "./storage.service";
import h from "../helper/helper";
var SessionService = /** @class */ (function () {
    function SessionService() {
        var _this = this;
        this.sid = "";
        this.loggedin = false;
        this.sessionStorage = withPrefix("whispeer.session");
        this.loginPromise = new Bluebird(function (loginResolve) {
            _this.loginResolve = loginResolve;
        });
        this.saveSession = function () {
            _this.sessionStorage.set("sid", _this.sid);
            _this.sessionStorage.set("userid", _this.userid);
            _this.sessionStorage.set("loggedin", true);
        };
        this.setLoginData = function (_sid, _userid) {
            _this.sid = _sid;
            _this.userid = parseInt(_userid, 10);
            _this.loggedin = true;
            _this.loginResolve();
        };
        this.awaitLogin = function () { return _this.loginPromise; };
        this.setPassword = function (password) {
            keyStore.security.setPassword(password);
            _this.sessionStorage.set("password", password);
        };
        this.bootLogin = h.cacheResult(function () { return _this.loadLogin(); });
        this.loadLogin = function () {
            return _this.sessionStorage.awaitLoading().then(function () {
                var loggedin = _this.sessionStorage.get("loggedin") === "true" && _this.sessionStorage.get("password");
                if (!loggedin) {
                    return _this.clear().thenReturn(false);
                }
                _this.setPassword(_this.sessionStorage.get("password"));
                _this.setLoginData(_this.sessionStorage.get("sid"), _this.sessionStorage.get("userid"));
                return true;
            });
        };
        this.getSID = function () { return _this.sid; };
        this.getUserID = function () { return _this.userid; };
        this.isOwnUserID = function (id) { return parseInt(id, 10) === _this.userid; };
        this.clear = function () {
            return Bluebird.all([
                _this.sessionStorage.clear().then(function () { return console.log("session storage"); }),
                Bluebird.resolve(Cache.deleteDatabase()).then(function () { return console.log("cache deletedb"); }),
            ].map(function (p) { return p.reflect(); }));
        };
        this.logout = function () { return _this.clear().finally(landingPage); };
        this.isLoggedin = function () { return _this.loggedin; };
    }
    return SessionService;
}());
export { SessionService };
export default new SessionService();



//////////////////
// WEBPACK FOOTER
// ./js/services/session.service.ts
// module id = 0kGL
// module chunks = 1 2 3